// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file <INSERT_FILE_DESCRIPTION_HERE>
 * @author James Reid
 */

// @ts-check

// @@imports-package
/* eslint-disable no-unused-vars -- Type imports. */
import { Membrane } from "../products/index.js"
import { Bom } from "../stock/index.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@imports-utils
/* eslint-disable no-unused-vars -- Type imports. */
import { DoubleLinkedListNode } from "../utils/index.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/**
 * 
 * @typedef {object} MembraneOption
 * @property {string} id
 * @property {boolean} flipped
 * @property {object} width
 * @property {number} width.membrane
 * @property {number} width.deck
 * @property {number} width.waste
 * @property {number} depth
 * @property {object} variance
 * @property {number} variance.option
 * @property {number} variance.stock
 * @property {number} wasteScore
 * @property {Array.<DoubleLinkedListNode.<Membrane>>} nodes
 * @property {Membrane[]} membranes
 * @property {object} seams
 * @property {number} seams.count
 * @property {number} seams.length
 * @property {number[]} widths
 * @property {Bom} bom
 */

// @@exports
/**
 * @type {MembraneOption}
 * @ignore
 */
export let MembraneOption
